import * as React from 'react'

import { useDispatch } from 'react-redux'

import { trackUserAddRemoveRecipe } from 'actions/loggingmanager'
import type { RecipeCoreId } from 'reducers/menu-recipes/recipes'

import { type AddRecipeInfo, useAddValidRecipeToBasket } from './useAddValidRecipeToBasket'

export type AddRecipeFn = ReturnType<typeof useAddRecipe>
export const useAddRecipe = () => {
  const addValidRecipeToBasket = useAddValidRecipeToBasket()
  const dispatch = useDispatch()

  return React.useCallback(
    (
      coreRecipeId: RecipeCoreId,
      view?: string,
      recipeInfo?: AddRecipeInfo,
      orderId?: string,
      isOrderRecipe?: boolean,
    ) => {
      addValidRecipeToBasket(coreRecipeId, view, recipeInfo, orderId, isOrderRecipe)
      dispatch(trackUserAddRemoveRecipe())
    },
    [dispatch, addValidRecipeToBasket],
  )
}
